/* ============================================
   FLORYA SCENTS - JavaScript
   ============================================ */

(function () {
  'use strict';

  /* =============================================
     UTILITY HELPERS
  ============================================= */
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  const on = (el, event, handler, options) => el && el.addEventListener(event, handler, options);
  const off = (el, event, handler) => el && el.removeEventListener(event, handler);

  /* =============================================
     HEADER SCROLL EFFECT
  ============================================= */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
  }

  /* =============================================
     MOBILE NAV
  ============================================= */
  const mobileNavOpen = $('.js-mobile-nav-open, .site-header__menu-toggle');
  const mobileNavClose = $('.js-mobile-nav-close');
  const mobileNav = $('.mobile-nav');
  const overlay = $('.overlay');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('is-open');
    overlay && overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  on(mobileNavOpen, 'click', openMobileNav);
  on(mobileNavClose, 'click', closeMobileNav);
  on(overlay, 'click', () => {
    closeMobileNav();
    closeSearch();
    closeCartDrawer();
  });

  /* =============================================
     SEARCH BAR
  ============================================= */
  const searchBar = $('.search-bar');
  const searchOpen = $('.js-search-open');
  const searchClose = $('.js-search-close');
  const searchInput = searchBar && $('.search-bar__input', searchBar);

  function openSearch() {
    searchBar && searchBar.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }

  function closeSearch() {
    searchBar && searchBar.classList.remove('is-open');
    if (!mobileNav?.classList.contains('is-open')) {
      overlay && overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  on(searchOpen, 'click', openSearch);
  on(searchClose, 'click', closeSearch);

  on(document, 'keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileNav();
      closeCartDrawer();
    }
  });

  /* =============================================
     CART DRAWER
  ============================================= */
  const cartDrawer = $('.cart-drawer');

  function openCartDrawer() {
    cartDrawer && cartDrawer.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    if (!mobileNav?.classList.contains('is-open')) {
      overlay && overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  $$('.js-cart-drawer-open').forEach(btn => on(btn, 'click', (e) => {
    e.preventDefault();
    openCartDrawer();
  }));

  $$('.js-cart-drawer-close').forEach(btn => on(btn, 'click', closeCartDrawer));

  /* =============================================
     QUANTITY SELECTOR
  ============================================= */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quantity-selector__btn');
    if (!btn) return;
    const input = btn.closest('.quantity-selector')?.querySelector('.quantity-selector__input');
    if (!input) return;

    let val = parseInt(input.value, 10) || 1;
    if (btn.dataset.action === 'increase') val++;
    if (btn.dataset.action === 'decrease') val = Math.max(1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* =============================================
     PRODUCT GALLERY THUMBNAILS
  ============================================= */
  const mainGallery = $('.product-gallery__main');
  const thumbs = $$('.product-gallery__thumb');
  const mainImg = mainGallery && $('img', mainGallery);

  thumbs.forEach((thumb) => {
    on(thumb, 'click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        const src = thumb.dataset.src || $('img', thumb)?.src;
        if (src) mainImg.src = src;
      }
    });
  });

  /* =============================================
     PRODUCT VARIANT SELECTION
  ============================================= */
  const variantSwatches = $$('.variant-swatch');

  variantSwatches.forEach((swatch) => {
    on(swatch, 'click', () => {
      const group = swatch.closest('.variant-group');
      if (!group) return;
      $$('.variant-swatch', group).forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');

      const selectedDisplay = group.querySelector('.variant-group__selected');
      if (selectedDisplay) selectedDisplay.textContent = swatch.textContent.trim();
    });
  });

  /* =============================================
     TABS (Product page tabs, etc.)
  ============================================= */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.tab-btn');
    if (!btn) return;
    const tabs = btn.closest('.tabs');
    const container = tabs?.closest('[data-tabs-container]') || tabs?.parentElement;
    if (!tabs || !container) return;

    const targetId = btn.dataset.tab;

    $$('.tab-btn', tabs).forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    $$('.tab-content', container).forEach(c => {
      c.classList.toggle('active', c.dataset.tabContent === targetId);
    });
  });

  /* =============================================
     SCROLL REVEAL ANIMATION
  ============================================= */
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );

    $$('.reveal').forEach((el) => revealObserver.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  /* =============================================
     ANNOUNCEMENT BAR AUTO-ROTATE
  ============================================= */
  const announcementItems = $$('.announcement-bar__item');
  if (announcementItems.length > 1) {
    let currentIdx = 0;
    const rotateAnnouncements = () => {
      announcementItems[currentIdx].classList.remove('is-active');
      currentIdx = (currentIdx + 1) % announcementItems.length;
      announcementItems[currentIdx].classList.add('is-active');
    };
    announcementItems[0].classList.add('is-active');
    setInterval(rotateAnnouncements, 4000);
  }

  /* =============================================
     STICKY ADD TO CART (Product page)
  ============================================= */
  const productForm = $('.product-form');
  const stickyBar = $('.sticky-atc');

  if (productForm && stickyBar) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0.5 }
    );
    observer.observe(productForm);
  }

  /* =============================================
     NEWSLETTER FORM
  ============================================= */
  const newsletterForms = $$('.newsletter-form');
  newsletterForms.forEach((form) => {
    on(form, 'submit', async (e) => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn = form.querySelector('button[type="submit"]');
      const successMsg = form.nextElementSibling;

      if (!input || !input.value) return;

      const originalText = btn?.textContent;
      if (btn) {
        btn.textContent = 'Subscribing...';
        btn.disabled = true;
      }

      try {
        const formData = new FormData(form);
        const response = await fetch(form.action || '/contact#newsletter', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' },
        });

        if (response.ok) {
          form.style.display = 'none';
          if (successMsg && successMsg.classList.contains('newsletter-success')) {
            successMsg.style.display = 'block';
          } else {
            const msg = document.createElement('p');
            msg.className = 'alert alert-success';
            msg.textContent = 'Thank you for subscribing! Welcome to Florya Scents.';
            form.parentNode.appendChild(msg);
          }
        }
      } catch (err) {
        console.error('Newsletter error:', err);
      } finally {
        if (btn) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      }
    });
  });

  /* =============================================
     ADD TO CART (AJAX)
  ============================================= */
  const addToCartForms = $$('.product-form:not([data-no-ajax])');

  addToCartForms.forEach((form) => {
    on(form, 'submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn) return;

      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' },
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        const item = await response.json();

        // Update cart count
        await updateCartCount();

        // Open cart drawer if available
        if (cartDrawer) {
          await refreshCartDrawer();
          openCartDrawer();
        } else {
          submitBtn.textContent = 'Added!';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
          return;
        }

      } catch (err) {
        console.error('Add to cart error:', err);
        submitBtn.textContent = 'Error - Try Again';
      } finally {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = $$('.cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (err) {
      console.error('Cart count update error:', err);
    }
  }

  async function refreshCartDrawer() {
    if (!cartDrawer) return;
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('.cart-drawer');
      if (newDrawer && cartDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
      }
    } catch (err) {
      console.error('Cart drawer refresh error:', err);
    }
  }

  /* =============================================
     FILTER SIDEBAR TOGGLE (mobile)
  ============================================= */
  const filterToggle = $('.js-filter-toggle');
  const filterSidebar = $('.sidebar-filters');

  on(filterToggle, 'click', () => {
    filterSidebar?.classList.toggle('is-open');
  });

  /* =============================================
     FILTER GROUP ACCORDION
  ============================================= */
  $$('.filter-group__title').forEach(title => {
    on(title, 'click', () => {
      const group = title.closest('.filter-group');
      group?.classList.toggle('is-collapsed');
    });
  });

  /* =============================================
     IMAGE LAZY LOAD FALLBACK
  ============================================= */
  if (!('loading' in HTMLImageElement.prototype)) {
    const lazyImages = $$('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          imageObserver.unobserve(img);
        }
      });
    });
    lazyImages.forEach(img => imageObserver.observe(img));
  }

  /* =============================================
     INITIALIZE ON DOM READY
  ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    updateCartCount();

    // Activate first tab in each tab group
    $$('[data-tabs-container]').forEach(container => {
      const firstBtn = container.querySelector('.tab-btn');
      if (firstBtn && !container.querySelector('.tab-btn.active')) {
        firstBtn.classList.add('active');
        const target = firstBtn.dataset.tab;
        const content = container.querySelector(`[data-tab-content="${target}"]`);
        content?.classList.add('active');
      }
    });

    // Animate hero content on load
    const heroContent = $('.hero__content');
    if (heroContent) {
      heroContent.style.opacity = '0';
      heroContent.style.transform = 'translateY(30px)';
      setTimeout(() => {
        heroContent.style.transition = 'opacity 1s ease, transform 1s ease';
        heroContent.style.opacity = '1';
        heroContent.style.transform = 'translateY(0)';
      }, 200);
    }
  });

})();
